import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import useSeo from "../hooks/useSeo";
import { AI_MODULE_GROUPS } from "../components/AiModuleTabs";

const HUB_META = {
  relationship: {
    path: "/ai/hub/relationship",
    title: "AI关系地图",
    description: "爱情地图、关系地图与关系模拟，帮助你理解自己和关系。",
  },
  persona: {
    path: "/ai/hub/persona",
    title: "数字人格",
    description: "AI人格与数字分身，认识自己，也让 AI 更好地代表你。",
  },
  advisor: {
    path: "/ai/hub/advisor",
    title: "AI婚恋顾问",
    description: "恋爱助手、婚姻顾问与 AI 咨询师，学习沟通与经营关系。",
  },
};

export default function AiHubPage({ groupKey }) {
  const meta = HUB_META[groupKey];
  const group = AI_MODULE_GROUPS[groupKey];

  useSeo({
    title: `${meta.title} | 婚恋有道`,
    metaDescription: meta.description,
    path: meta.path,
    noindex: true,
  });

  if (!group) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-orange-50 flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 py-10">
        <p className="text-sm text-rose-500 font-medium mb-2">AI 婚恋成长</p>
        <h1 className="text-3xl font-extrabold text-stone-900 mb-2">{group.title}</h1>
        <p className="text-stone-500 mb-8">{group.subtitle}</p>

        <div className="space-y-4">
          {group.tabs.map((tab) => (
            <Link
              key={tab.key}
              to={tab.to}
              className="block bg-white rounded-2xl border border-rose-100 p-5 shadow-sm hover:border-rose-300 transition"
            >
              <h2 className="text-lg font-bold text-stone-900">{tab.label}</h2>
              <p className="text-sm text-stone-500 mt-1">{tab.hint}</p>
              <span className="inline-block mt-3 text-sm text-rose-600">进入 →</span>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link to="/discover" className="text-sm text-rose-600 underline">
            先去寻找对象
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
